import { render } from "./glpi.vue?vue&type=template&id=5ca7715a&scoped=true"
import script from "./glpi.vue?vue&type=script&lang=js"
export * from "./glpi.vue?vue&type=script&lang=js"

import "./glpi.vue?vue&type=style&index=0&id=5ca7715a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca7715a"]])

export default __exports__